import * as types from './types';
import actions from './actions';
import {
  extend,
} from 'lodash';

const state = {
  toolBookStatementStudentList:{
    state : '',
    total : undefined,
    list : []
  },
  toolBookStatementStudentCourseList : {
    state : '',
    total : undefined,
    list : []
  }
};

const getters = {
  getToolBookStatementStudentList : (state) => state.toolBookStatementStudentList,// 学生列表
  getToolBookStatementStudentCourseList : (state) => state.toolBookStatementStudentCourseList// 学生导入列表
};

const mutations = {
  //学生列表
  [types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_LIST]({toolBookStatementStudentList},query){
   extend(toolBookStatementStudentList,query);
  },
  // 学生导入列表
  [types.ADMIN_TOOL_BOOK_STATEMENT_STUDENT_COURSE_LIST]({toolBookStatementStudentCourseList},query){
    extend(toolBookStatementStudentCourseList,query);
  }
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/semesterStudentMoney/index.js